(ns frontend.view.entity-merge.contact-lists
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.state.current-session :as session]
   [frontend.view.entity-merge.components :as components]))

(defn review
  [{:keys [state r-target r-source] :as signals}]
  (let [target @r-target
        entity-type (:entity/type target)
        target-label (entity/display-string target)
        containing-contact-lists @(:r-containing-contact-lists signals)
        list-count (count containing-contact-lists)]
    (when (and (session/contact-lists?)
               (= entity-type :entity.type/person)
               (seq containing-contact-lists))
      [components/review-card signals
       {:title          (loc/tr :contact-lists)
        :collapsed-path [:review-contact-lists]
        :content
        [:div
         [:p "The entities to be merged are members in "
          [:strong list-count]
          (if (< 1 list-count)
            " contact lists."
            " contact list.")]
         [:p
          (str "The new contact '"
               target-label
               "' will replace the old entities in each of the contact lists.")]]}])))
